function formatDate(dateString, options = null, locale= 'en') {
  var date = new Date(dateString);
  if (options) {
    return date.toLocaleDateString(`${locale}-CA`, options)
  }
  return date.toLocaleDateString('en-CA').slice(0,10);
}

function formatLogbookHours(rowObj) {
  if(parseInt(rowObj)) {
    return rowObj.toFixed(2);
  }
  return rowObj
}

function commonizeTimeFormat(time) {
  let pmModifier = time.includes('PM')
  time = time.replace('AM', '')
  time = time.replace('PM', '')

  let [hours, minutes] = time.split(':');

  if (hours === '12') {
    hours = '00';
  }

  if (pmModifier) {
    hours = parseInt(hours, 10) + 12;
  }

  time = `${hours}:${minutes}`;

  time = time.replace("h", ':')

  let split_time = time.split(':')
  return {
    hours: split_time[0],
    minutes: split_time[1]
  }
}

let formatTimeByKeys = {
  "%H": formatHours,
  "%-l": format12Hours,
  "%M": formatMinutes,
  "%p": formatMeridianIndicator
}
function formatHours(string, time) {
  string = string.replace("%H", time.getHours())
  return string
}
function format12Hours(string, time) {
  let hours = time.getHours();
  hours = (hours % 12) || 12;
  string = string.replace("%-l", hours)
  return string
}
function formatMinutes(string, time) {
  let minutes = time.getMinutes()
  const minutesToS = minutes < 10 ? `0${minutes}` : minutes.toString()
  string = string.replace("%M", minutesToS)
  return string
}
function formatMeridianIndicator(string, time) {
  let hours = time.getHours();
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = (hours % 12) || 12;
  string = string.replace("%p", ampm)
  return string
}

function formatTime(date, format, fallback = null) {
  if (date === null) {
    if (fallback === null) {
        return fallback;
    } 
    return fallback.getHours() + ':' + fallback.getMinutes();
  }

  const dateObj = new Date(date);

  //Iterate through keys in formatTimeByKeys. If a key is found in our format string it will replace it accordingly.
  var newDate = ""
  for (const property in formatTimeByKeys) {
    if (format.includes(property)) {
      format = formatTimeByKeys[property](format, dateObj);
    }
  }
  return format
}

export {formatDate, formatLogbookHours, formatTime, commonizeTimeFormat}

// All srftime date functions From http://linux.die.net/man/3/strftime    

//   %a - The abbreviated weekday name (``Sun'')
//   %A - The  full  weekday  name (``Sunday'')
//   %b - The abbreviated month name (``Jan'')
//   %B - The  full  month  name (``January'')
//   %c - The preferred local date and time representation
//   %d - Day of the month (01..31)
//   %e - Day of the month without leading 0 (1..31) 
//   %g - Year in YY (00-99)
//   %H - Hour of the day, 24-hour clock (00..23)
//   %I - Hour of the day, 12-hour clock (01..12)
//   %j - Day of the year (001..366)
//   %m - Month of the year (01..12)
//   %M - Minute of the hour (00..59)
//   %p - Meridian indicator (``AM''  or  ``PM'')
//   %S - Second of the minute (00..60)
//   %U - Week  number  of the current year,
//           starting with the first Sunday as the first
//           day of the first week (00..53)
//   %W - Week  number  of the current year,
//           starting with the first Monday as the first
//           day of the first week (00..53)
//   %w - Day of the week (Sunday is 0, 0..6)
//   %x - Preferred representation for the date alone, no time
//   %X - Preferred representation for the time alone, no date
//   %y - Year without a century (00..99)
//   %Y - Year with century
//   %Z - Time zone name
//   %% - Literal ``%'' character    
